import { READABLE_MDF_FIELDS_QUERY_PARAMETER } from '../dto/itemModelPrimitives';

export function applyItemQueryParameterDefaults(queryParams: Record<string, string>) {
  return {
    ...queryParams,
    [READABLE_MDF_FIELDS_QUERY_PARAMETER]: queryParams[READABLE_MDF_FIELDS_QUERY_PARAMETER] ?? 'false'
  };
}

